import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstanceg4mecbw0mfx8 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation, requestUuid, data, errors, extensions, exception) {
        return new.target.r41(operation, requestUuid, data, errors, extensions, exception);
      }
      static r41(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.j41_1 = operation;
        $this.k41_1 = requestUuid;
        $this.l41_1 = data;
        $this.m41_1 = errors;
        $this.n41_1 = extensions;
        $this.o41_1 = exception;
        $this.p41_1 = Companion_getInstance().a40_1;
        $this.q41_1 = false;
        return $this;
      }
      static s41(operation, requestUuid) {
        return this.r41(operation, requestUuid, null, null, null, null);
      }
      t41(executionContext) {
        // Inline function 'kotlin.apply' call
        this.p41_1 = this.p41_1.u41(executionContext);
        return this;
      }
      v41(data) {
        // Inline function 'kotlin.apply' call
        this.l41_1 = data;
        return this;
      }
      w41(errors) {
        // Inline function 'kotlin.apply' call
        this.m41_1 = errors;
        return this;
      }
      x41(exception) {
        // Inline function 'kotlin.apply' call
        this.o41_1 = exception;
        return this;
      }
      q40(extensions) {
        // Inline function 'kotlin.apply' call
        this.n41_1 = extensions;
        return this;
      }
      b40(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.k41_1 = requestUuid;
        return this;
      }
      y41(isLast) {
        // Inline function 'kotlin.apply' call
        this.q41_1 = isLast;
        return this;
      }
      i37() {
        var tmp1_operation = this.j41_1;
        var tmp2_requestUuid = this.k41_1;
        var tmp3_data = this.l41_1;
        var tmp4_executionContext = this.p41_1;
        var tmp0_elvis_lhs = this.n41_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.m41_1;
        var tmp7_exception = this.o41_1;
        var tmp8_isLast = this.q41_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.z41_1 = requestUuid;
        this.a42_1 = operation;
        this.b42_1 = data;
        this.c42_1 = errors;
        this.d42_1 = exception;
        this.e42_1 = extensions;
        this.f42_1 = executionContext;
        this.g42_1 = isLast;
      }
      h42() {
        var tmp;
        if (this.v42()) {
          throw ApolloGraphQLException().u42(first(ensureNotNull(this.c42_1)));
        } else if (!(this.d42_1 == null)) {
          throw DefaultApolloException().n42('An exception happened', this.d42_1);
        } else {
          tmp = this.i42();
        }
        return tmp;
      }
      i42() {
        var tmp0_elvis_lhs = this.b42_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().a43(this.d42_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v42() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.c42_1;
        return !(this_0 == null || this_0.n1());
      }
      h41() {
        return Builder().r41(this.a42_1, this.z41_1, this.b42_1, this.c42_1, this.e42_1, this.d42_1).t41(this.f42_1).y41(this.g42_1);
      }
      toString() {
        var tmp = 'operationName=' + this.a42_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.b42_1 == null ? 'null' : this.a42_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.c42_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.d42_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.d42_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
